export { EDITOR_TYPE, CheckboxEditor } from "./checkboxEditor.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/checkboxEditor/index.mjs
// module id = 444
// module chunks = 1